module.exports = __webpack_public_path__ + "static/media/logo192.f6e8279c.png";